var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveTable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "first-card",
    d: "M15 1H2a1 1 0 00-1 1v20a1 1 0 001 1h13a1 1 0 001-1V2a1 1 0 00-1-1z",
    fill: "transparent",
    stroke: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "second-card",
    d: "M34 1H21a1 1 0 00-1 1v20a1 1 0 001 1h13a1 1 0 001-1V2a1 1 0 00-1-1z",
    fill: "transparent",
    stroke: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "third-card",
    d: "M9.743 11.843l.76 2.088-1.87-1.28-1.799 1.311.643-2.1-1.871-1.28 2.27-.019.641-2.1.757 2.088 2.268-.02-1.799 1.312zm1.47-3.408C9.52 6.853 8.444 5.87 8.444 5.87s-1.023 1-2.622 2.611c-.846.85-2.74 2.958-2.683 5.037.038 1.387 1.226 2.502 2.653 2.489.937-.008 1.46-.282 2.174-1.229 0 0 .117-.099.201-.1.133 0 .256.09.246.203-.08.748-.462 2.595-2.152 3.231l5.042-.043c-1.726-.607-2.209-2.446-2.328-3.193-.019-.112.1-.204.233-.206.082 0 .207.096.207.096.749.75 1.303 1.2 2.24 1.19 1.426-.01 2.553-1.145 2.513-2.531-.057-2.08-2.067-4.155-2.957-4.99z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "fourth-card",
    d: "M28.743 11.843l.76 2.088-1.87-1.28-1.799 1.311.643-2.1-1.871-1.28 2.27-.019.641-2.1.757 2.088 2.268-.02-1.799 1.312zm1.47-3.408C28.52 6.853 27.444 5.87 27.444 5.87s-1.023 1-2.622 2.611c-.846.85-2.74 2.958-2.683 5.037.038 1.387 1.226 2.502 2.653 2.489.937-.008 1.46-.282 2.174-1.229 0 0 .117-.099.201-.1.133 0 .256.09.246.203-.08.748-.462 2.595-2.152 3.231l5.042-.043c-1.726-.607-2.209-2.446-2.328-3.193-.019-.112.1-.204.233-.206.082 0 .207.096.207.096.749.75 1.303 1.2 2.24 1.19 1.426-.01 2.553-1.145 2.513-2.531-.057-2.08-2.066-4.155-2.957-4.99z",
    fill: "#fff"
  })));
}
SvgActiveTable.displayName = 'ActiveTable';
export default SvgActiveTable;